// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1tIlb","overflowing":"ReadFullNote_overflowing__3kUL5"};